export default {
  orderStatus: {
    0: 'Złożyłeś zamówienie, poczekaj na przyjęcie zamówienia przez agenta zakupowego',
    23: 'Agent zakupowy otrzymał zamówienie i kontaktuje się ze sprzedawcą',
    22: 'Twoje towary zostały zamówione, numer transakcji: ',
    5: 'Sprzedawca wysłał towar, metoda wysyłki: ',
    10: 'Twój produkt dotarł do Wybrany magazyn acbuy',
    16: 'Twoje żądanie zwrotu zostało przesłane. Proszę czekać, aż agent je przetworzy',
    17: 'Twoje żądanie wymiany zostało przesłane. Proszę czekać, aż agent je przetworzy',
    buyerReturn:
      'Agent złożył wniosek o zwrot z powodu potrzeb klienta, ryzyka przedmiotu itp. Proszę czekać na przetworzenie',
    buyerReplace:
      'Agent złożył wniosek o wymianę z powodu potrzeb klienta, ryzyka przedmiotu itp. Proszę czekać na przetworzenie',
    20: 'Zamówienie zostało zwrócone',
    beenReturned: ' Sprawdź zwroty >',
    30: 'Twoja przesyłka została wysłana, sprawdź gdzie znajduje się paczka: ',
    43: 'Twoja prośba o zwrot została anulowana',
    44: 'Twoja prośba o wymianę została anulowana',
    49: 'Jeżeli użytkownik nie odnowi usługi przechowywania, produkt zostanie domyślnie porzucony',
  },
  expressNo: 'Numer śledzenia: ',
}
